import { render, staticRenderFns } from "./ContractorChangeStatus.vue?vue&type=template&id=56ac9752&scoped=true"
import script from "./ContractorChangeStatus.vue?vue&type=script&lang=js"
export * from "./ContractorChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac9752",
  null
  
)

export default component.exports